module.exports = __webpack_public_path__ + "media/images/common/detail_2-23fe74abd305c166ad9e32955647c1fb.png";